import React, { Fragment, useEffect } from 'react';

import Description from '../Template/Description';
import axios from '../../../axios-orders'

function Final(props) {
    props.sendData()

    return (
        <Fragment>
            <Description
                content={
                    <Fragment>
                        題目做完拉！
                    </Fragment>
                }
                title={
                    <Fragment>
                        恭喜！
                    </Fragment>
                }
                buttonText={
                    <Fragment>
                        看看我的分數
                    </Fragment>

                }
                buttonClick={
                    () => { props.history.push("/leaderboard") }
                }
            />
        </Fragment>

    )
}

export default Final
